import Store from '~/store'
import UsersAPI from 'api/UsersAPI'

export default {
    fetchReferralsCountByStatus(params, type) {
        return UsersAPI.getReferralsCountByStatus(params).then((res) => {
            type === 'received'
                ? Store.commit('auth/setPendingReferralActionReceived', res)
                : Store.commit('auth/setPendingReferralActionMade', res)
            Store.commit('auth/setPendingReferralActionReceived', res)
            return res
        })
    },
}
